import { render, staticRenderFns } from "./BoProductCat.vue?vue&type=template&id=25505dc4&"
import script from "./BoProductCat.vue?vue&type=script&lang=js&"
export * from "./BoProductCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports